<nz-drawer
  [nzVisible]="visible"
  [nzWidth]="drawerWidth"
  [nzWrapClassName]="'tenant-contact-detail-drawer'"
  [nzBodyStyle]="{ padding: '0' }"
  nzTitle="客戶詳情"
  (nzOnClose)="onClose()"
  testId="tenant-contact-detail-drawer"
>
  <ng-container *nzDrawerContent>
    <div class="drawer-scroll">
      <section class="customer-context" testId="tenant-contact-detail-header">
        <nz-avatar
          [nzSrc]="
            contact?.avatarUrl ||
            contact?.fallbackAvatarUrl ||
            AvatarFactory.defaultAvatarWithName(contact?.name || contact?.alias || contact?.id || 'U')
          "
          [nzSize]="56"
          testId="tenant-contact-detail-avatar"
        />
        <div class="customer-identity">
          <div class="identity-line">
            <h2>{{ displayName }}</h2>
            <nz-tag [nzColor]="getChannelColor(contact?.channel)">{{ getChannelText(contact?.channel) }}</nz-tag>
            <nz-tag [nzColor]="getStatusColor(contact?.status)">{{ getStatusTextKey(contact?.status) | i18n }}</nz-tag>
          </div>
          <p *ngIf="contact?.alias && contact?.alias !== contact?.name">{{ contact?.alias }}</p>
          <div class="identity-meta">
            <span>{{ 'tenant.contact.type' | i18n }}：{{ getTypeText(contact?.type) }}</span>
            <span>客戶 ID：{{ contact?.id || '-' }}</span>
            <span *ngIf="contact?.openId">Open ID：{{ contact?.openId }}</span>
          </div>
        </div>
      </section>

      <section class="profile-section" [class.collapsed]="!profileExpanded">
        <button
          class="section-title profile-toggle"
          type="button"
          [attr.aria-expanded]="profileExpanded"
          (click)="toggleProfile()"
          testId="tenant-contact-profile-toggle"
        >
          <div
            ><h3>客戶檔案</h3><p>{{ hasProfileData ? '身份、聯絡方式與企業資料' : '暫無身份、聯絡與企業資料' }}</p></div
          >
          <i nz-icon [nzType]="profileExpanded ? 'up' : 'down'"></i>
        </button>
        <div class="profile-content" *ngIf="profileExpanded" testId="tenant-contact-profile-content">
          <div class="profile-groups">
            <div class="profile-group">
              <h4>聯絡方式</h4>
              <dl>
                <div
                  ><dt>電話</dt><dd>{{ contact?.phone || '-' }}</dd></div
                >
                <div
                  ><dt>電子郵件</dt><dd>{{ contact?.email || '-' }}</dd></div
                >
                <div
                  ><dt>語言</dt><dd>{{ contact?.languages?.join(', ') || '-' }}</dd></div
                >
              </dl>
            </div>
            <div class="profile-group">
              <h4>個人資料</h4>
              <dl>
                <div
                  ><dt>性別</dt><dd>{{ contact?.gender || '-' }}</dd></div
                >
                <div
                  ><dt>生日</dt><dd>{{ contact?.birthday || '-' }}</dd></div
                >
                <div
                  ><dt>婚姻狀態</dt><dd>{{ contact?.maritalStatus || '-' }}</dd></div
                >
                <div
                  ><dt>興趣</dt><dd>{{ contact?.interests || '-' }}</dd></div
                >
              </dl>
            </div>
            <div class="profile-group">
              <h4>企業資料</h4>
              <dl>
                <div
                  ><dt>公司</dt><dd>{{ contact?.company || '-' }}</dd></div
                >
                <div
                  ><dt>部門 / 職務</dt><dd>{{ contact?.companyDepartment || '-' }} / {{ contact?.companyDuty || '-' }}</dd></div
                >
                <div
                  ><dt>公司電話</dt><dd>{{ contact?.companyPhone || '-' }}</dd></div
                >
                <div
                  ><dt>公司信箱</dt><dd>{{ contact?.companyEmail || '-' }}</dd></div
                >
                <div
                  ><dt>公司地址</dt><dd>{{ contact?.companyAddress || '-' }}</dd></div
                >
              </dl>
            </div>
          </div>
        </div>
        <div class="description-row" testId="tenant-contact-remark"
          ><span>備註</span><p>{{ contact?.description || '-' }}</p></div
        >
        <div class="record-times">
          <span>建立時間 {{ formatTime(contact?.createTime) }}</span>
          <span>最近更新 {{ formatTime(contact?.updateTime) }}</span>
        </div>
      </section>

      <section class="journey-section" *ngIf="contact?.id">
        <header class="section-title"
          ><div><h3>服務接觸記錄</h3><p>此客戶進入過的服務號與進線歷程</p></div></header
        >
        <tenant-contact-journey [tenantId]="tenantId" [contactId]="contact!.id!" [roomOnly]="true" (roomSelected)="openRoom($event)" />
      </section>
    </div>
  </ng-container>
</nz-drawer>
